import { Version } from "src/app/api/models";

export class VersionHelper {
  static format(version: Version): string {
    let result;
    const commitTime = version.commitTime != undefined ? version.commitTime.replaceAll('-', '').split('T')[0] : '';
        if (version.tagCommitCount != 0) {
          result = version.tagName + '-' + version.tagCommitCount + '-' + commitTime;
        }
        else {
          result = version.tagName + '-' + commitTime;
        }
    return result;
  }

}
